import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
);

const ChartComponent = ({ dataset, title, subtitle, maxPowerDb }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const fullScreenStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    background: "white",
    transition: "all 0 ease",
  };

  const normalStyle = {
    width: "100%",
    height: "215px",
    margin: "0",
    padding: "5px",
  };

  const handleChartClick = () => {
    if (!isFullScreen) {
      setIsFullScreen(true);
    }
  };

  const handleExitFullScreen = () => {
    setIsFullScreen(false);
  };

  const showTitle = () => {
    if (title) {
      return (
        <CardHeader>
          <CardTitle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h6
                style={{
                  fontSize: isFullScreen ? "30px" : "18px",
                  margin: 0,
                }}
              >
                {title}
              </h6>
              {!isFullScreen ? showMaxPowerDb() : ""}
            </div>
          </CardTitle>
          {subtitle ? <p className="card-category">subtitle</p> : ""}
        </CardHeader>
      );
    } else {
      return "";
    }
  };

  const showMaxPowerDb = () => {
    if (maxPowerDb) {
      return (
        <span style={{ fontWeight: "bold", color: "rgba(79, 129, 189, 1)" }}>
          MAX: {maxPowerDb}
        </span>
      );
    }
    return "";
  };

  return (
    <>
      <Card
        className="card-chart h-full flex flex-col"
        onClick={handleChartClick}
      >
        {showTitle()}
        <CardBody className="p-0 flex-grow">
          <div style={isFullScreen ? fullScreenStyle : normalStyle}>
            {isFullScreen && (
              <>
                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "10px",
                    zIndex: 10000,
                  }}
                >
                  <button
                    onClick={handleExitFullScreen}
                    style={{
                      padding: "5px 15px",
                      cursor: "pointer",
                    }}
                  >
                    Leave Full Screen Mode
                  </button>
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "60px",
                    right: "60px",
                    zIndex: 10000,
                  }}
                >
                  {showMaxPowerDb()}
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "0px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 10000,
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {showTitle()}
                </div>
              </>
            )}
            <Line
              data={dataset.data}
              options={{
                ...dataset.options,
                responsive: true,
                maintainAspectRatio: false,
              }}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default ChartComponent;
